import { cn } from '@/lib/utils';

export interface StethoscopeProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size applied to both width and height.
   */
  size?: number;
  /**
   * Optional explicit width (overrides size).
   */
  width?: number;
  /**
   * Optional explicit height (overrides size).
   */
  height?: number;
  /**
   * Fill color for the icon.
   */
  color?: string;
}

export function Stethoscope({
  size = 20,
  width,
  height,
  color = '#3C4F1E',
  className,
  ...props
}: StethoscopeProps) {
  const w = width ?? size;
  const h = height ?? size;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 20 20"
      fill="none"
      className={cn('inline-block flex-shrink-0', className)}
      aria-hidden="true"
      {...props}
    >
      <path
        fill={color}
        d="M18.75 12.5C18.75 12.0322 18.6188 11.5737 18.3712 11.1768C18.1236 10.7798 17.7696 10.4603 17.3494 10.2546C16.9293 10.0488 16.4598 9.96513 15.9944 10.013C15.5291 10.0608 15.0864 10.2382 14.7169 10.5251C14.3474 10.812 14.0657 11.1968 13.9041 11.6358C13.7424 12.0748 13.7071 12.5504 13.8023 13.0085C13.8975 13.4665 14.1192 13.8886 14.4424 14.2269C14.7656 14.5652 15.1772 14.8059 15.6305 14.9219C15.627 14.9478 15.6252 14.9739 15.625 15C15.625 15.663 15.3616 16.2989 14.8928 16.7678C14.4239 17.2366 13.788 17.5 13.125 17.5H11.25C10.587 17.5 9.95107 17.2366 9.48223 16.7678C9.01339 16.2989 8.75 15.663 8.75 15V11.8344C11.2086 11.5219 13.125 9.37578 13.125 6.81016V3.125C13.125 2.95924 13.0592 2.80027 12.9419 2.68306C12.8247 2.56585 12.6658 2.5 12.5 2.5H10.625C10.4592 2.5 10.3003 2.56585 10.1831 2.68306C10.0658 2.80027 10 2.95924 10 3.125C10 3.29076 10.0658 3.44973 10.1831 3.56694C10.3003 3.68415 10.4592 3.75 10.625 3.75H11.875V6.81016C11.875 8.88672 10.2148 10.5984 8.175 10.625C7.67835 10.6316 7.18534 10.5395 6.72458 10.354C6.26382 10.1685 5.8445 9.89337 5.49097 9.54449C5.13743 9.1956 4.85673 8.77997 4.66516 8.32171C4.47358 7.86345 4.37496 7.37169 4.375 6.875V3.75H5.625C5.79076 3.75 5.94973 3.68415 6.06694 3.56694C6.18415 3.44973 6.25 3.29076 6.25 3.125C6.25 2.95924 6.18415 2.80027 6.06694 2.68306C5.94973 2.56585 5.79076 2.5 5.625 2.5H3.75C3.58424 2.5 3.42527 2.56585 3.30806 2.68306C3.19085 2.80027 3.125 2.95924 3.125 3.125V6.875C3.12515 8.09273 3.5697 9.26855 4.37521 10.1818C5.18072 11.095 6.29182 11.6829 7.5 11.8352V15C7.50103 15.9942 7.89645 16.9475 8.59949 17.6505C9.30253 18.3535 10.2558 18.749 11.25 18.75H13.125C14.1192 18.749 15.0725 18.3535 15.7755 17.6505C16.4785 16.9475 16.874 15.9942 16.875 15C16.8748 14.9739 16.873 14.9478 16.8695 14.9219C17.4074 14.7843 17.8842 14.4716 18.2246 14.0331C18.5651 13.5946 18.75 13.0552 18.75 12.5ZM16.25 13.125C16.1264 13.125 16.0055 13.0883 15.9028 13.0197C15.8 12.951 15.7199 12.8534 15.6726 12.7392C15.6253 12.625 15.6129 12.4993 15.637 12.3781C15.6611 12.2568 15.7206 12.1455 15.8081 12.0581C15.8955 11.9706 16.0068 11.9111 16.1281 11.887C16.2493 11.8629 16.375 11.8753 16.4892 11.9226C16.6034 11.9699 16.701 12.05 16.7697 12.1528C16.8383 12.2555 16.875 12.3764 16.875 12.5C16.875 12.6658 16.8092 12.8247 16.6919 12.9419C16.5747 13.0592 16.4158 13.125 16.25 13.125Z"
      />
    </svg>
  );
}
